import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import '../App.css';

export default function CustomerLayout({ children }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = React.useState(true);

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const menuItems = [
        { to: '/dashboard', label: 'Dashboard', icon: '📊' },
        { to: '/invoices', label: 'Invoices', icon: '📄' },
        { to: '/tickets', label: 'Tickets', icon: '🎫' },
        { to: '/contracts', label: 'Contracts', icon: '📝' },
        { to: '/domains', label: 'Domains', icon: '🌐' },
        { to: '/assets', label: 'Assets', icon: '💼' },
        { to: '/profile', label: 'Profile', icon: '👤' },
        { to: '/marketplace', label: 'Marketplace', icon: '🛒' }
    ];

    return (
        <div style={{ minHeight: '100vh', display: 'flex' }}>
            {/* Sidebar */}
            <aside style={{
                width: sidebarOpen ? '250px' : '0',
                background: '#2c3e50',
                color: 'white',
                padding: sidebarOpen ? '20px' : '0',
                display: 'flex',
                flexDirection: 'column',
                transition: 'all 0.3s',
                overflow: 'hidden'
            }}>
                <h2 style={{ marginBottom: '10px', color: 'white' }}>Client Portal</h2>
                <p style={{ fontSize: '12px', opacity: 0.7, marginBottom: '30px' }}>
                    {user?.customerName}
                </p>
                <nav style={{ flex: 1 }}>
                    {menuItems.map((item) => (
                        <Link
                            key={item.to}
                            to={item.to}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '12px 16px',
                                color: 'white',
                                textDecoration: 'none',
                                borderRadius: '4px',
                                marginBottom: '8px',
                                background: window.location.pathname === item.to ? 'rgba(255,255,255,0.1)' : 'transparent',
                                transition: 'background 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
                            onMouseLeave={(e) => {
                                if (window.location.pathname !== item.to) {
                                    e.currentTarget.style.background = 'transparent';
                                }
                            }}
                        >
                            <span style={{ marginRight: '10px' }}>{item.icon}</span>
                            {item.label}
                        </Link>
                    ))}
                </nav>
                <button
                    className="btn"
                    style={{ background: '#e74c3c', color: 'white', width: '100%' }}
                    onClick={handleLogout}
                >
                    Logout
                </button>
            </aside>

            {/* Main content */}
            <main style={{ flex: 1, background: '#f5f5f5', position: 'relative' }}>
                {/* Mobile menu toggle */}
                <button
                    style={{
                        position: 'absolute',
                        top: '20px',
                        left: '20px',
                        background: '#2c3e50',
                        color: 'white',
                        border: 'none',
                        padding: '10px 15px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        zIndex: 100
                    }}
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                >
                    ☰
                </button>
                <div style={{ padding: '30px', paddingTop: '70px' }}>
                    {children}
                </div>
            </main>
        </div>
    );
}
